import { Link } from "react-router-dom";
import { Compass } from "lucide-react";
import { EmptyState, PageContainer, PageHeader } from "@/shared/ui";
import { Button } from "@/shared/ui/core";

export function NotFoundPage() {
  return (
    <PageContainer width="md">
      <PageHeader title="Ruta no encontrada" />
      <EmptyState
        icon={<Compass className="h-5 w-5 text-ds-violet-pop" />}
        title="Aquí no hay nada"
        description="La dirección que abriste no corresponde a ninguna pantalla de esta fase."
        action={
          <Link to="/health">
            <Button variant="secondary" size="sm">
              Ir al estado del sistema
            </Button>
          </Link>
        }
      />
    </PageContainer>
  );
}
